<template>
    <div>
        <div style="position: relative">
            <b-spinner v-if="loading" variant="primary"
                style="position: absolute;bottom:3px;right:20px;z-index: 999"></b-spinner>
            <l-map style="height: 92vh" :zoom="zoom" :center="center" ref="myMap" :options="{
                zoomControl: false,
                gestureHandling: gestureHandling,
                maxZoom: 18,
                attributionControl: false
            }" gestureHandling>
                <l-control-zoom position="topright" :options="zoomOption" />
                <l-control position="topright">
                    <div class="leaflet-bar">
                        <a @click="refreshMapView" title="Xem toàn cảnh" role="button" aria-label="Xem toàn cảnh"><i
                                class="fa fa-arrows-alt fa-lg" /></a>
                        <a @click="refreshMap" title="Làm mới bản đồ" role="button" aria-label="Làm mới bản đồ"><i
                                class="fa fa-refresh fa-lg" /></a>
                    </div>
                </l-control>

                <!-- <div v-for="item in listDataPoint">
                        <l-marker
                            :lat-lng="[item.lat, item.long]"
                            @click="openDataModal(item)"
                            v-if="!listGeoPoint.includes(item)"
                        >
                            <l-tooltip>{{ item.name }}</l-tooltip>
                            <l-icon>
                                <img src="/img/add.png" width="20" />
                            </l-icon>
                        </l-marker>
                    </div> -->
                <div>
                    <l-marker :lat-lng="[item.lat, item.long]" @click="openLayerModal(item)"
                        v-if="!listGeoPoint.includes(item)" v-for="item in listLayerPoint" :key="item.id">
                        <l-tooltip>{{ item.name }}</l-tooltip>
                        <l-icon>
                            <div class="station-bg" :style="{
                                backgroundColor: getMarkerColor1(item)
                            }">
                                <div class="font-weight-bold" :style="{
                                    backgroundColor: getMarkerColor2(item)
                                }">
                                    <span>{{ formatNumber(item?.data?.value) }}</span>
                                </div>
                            </div>
                        </l-icon>
                    </l-marker>
                </div>
                <div>
                    <l-marker :lat-lng="[item.lat, item.long]" v-for="item in listLayerPhoto" :key="item.id">
                        <l-tooltip>{{ item.description }}</l-tooltip>
                        <l-icon>
                            <img :src="getPhotoIcon(item)" :width="item.layer?.iconSize ?? 20" />
                        </l-icon>
                        <l-popup>
                            <b-carousel controls img-width="200" style="min-width: 200px;">
                                <b-carousel-slide v-for="path in item.images" :key="path">
                                    <template #img>
                                        <img v-if="isImage(path)" class="d-block img-fluid w-100" width="200"
                                            :src="API_CONFIG.BASE_URL + 'download?fileName=' + path" />
                                        <video v-else class="d-block img-fluid w-100" width="200" controls
                                            :src="API_CONFIG.BASE_URL + 'download?fileName=' + path"></video>
                                    </template>
                                </b-carousel-slide>
                            </b-carousel>
                            <p>{{ item.description }}</p>
                        </l-popup>
                    </l-marker>
                </div>
                <l-control position="topleft">
                    <div class="leaflet-bar">
                        <a @click="openUploadImageModal" title="Chụp ảnh" role="button" aria-label="Chụp ảnh"><i
                                class="fa fa-camera" /></a>
                    </div>
                </l-control>
            </l-map>
            <TifLegendInfo style="position: absolute; width: 100%; z-index: 999"
                :style="{ bottom: rasterInfo?.files.length > 1 ? '30px' : '10px' }"
                v-if="showLegend && lastLayerSelected?.dataType === 'raster'" :title="rasterInfo.name"
                :legend="rasterInfo.legend" />
            <TifLegendInfo style="position: absolute; width: 100%; z-index: 999"
                :style="{ bottom: rasterInfo?.files.length > 1 ? '30px' : '10px' }"
                v-if="showLegend && geoInfo && lastLayerSelected?.dataType === 'geojson'" :title="geoInfo.name"
                :legend="geoInfo.legend" />
            <Timeline v-if="rasterInfo?.files.length > 1"
                style="position: absolute; width: 100%; bottom: -15px; z-index: 999" :files="rasterInfo?.files"
                @time-change="onTimeChange" />
            <div style="position: absolute;top: 0px;left: 0px;z-index: 1000;height: 100%" ref="leftSidePanel">
                <div style="position: relative;height: 100%">
                    <div :style="{ display: showLeftSide ? 'block' : 'none' }"
                        style="width: 300px;background-color: #fff;height: 100%" class="pt-2 px-3">
                        <b-checkbox v-model="showLabel" size="sm">Hiển thị nhãn</b-checkbox>
                        <b-checkbox v-model="showLegend" size="sm">Hiển thị bảng chú giải</b-checkbox>
                        <div class="my-1">Bản đồ nền ( <i class="fa fa-map"></i> ):</div>
                        <treeselect :searchable="false" :options="listBaseMap" :normalizer="normalizer"
                            v-model="selectedBaseMap" :disable-branch-nodes="true" style="z-index: 1000;" multiple
                            valueFormat="object" placeholder="Chọn bản đồ nền" />
                        <div class="my-1 mt-4">Lớp dữ liệu ( <i class="fa fa-map-o"></i> ):</div>
                        <treeselect :searchable="false" class="mb-4" always-open :normalizer="normalizer"
                            :options="listLayerMap" v-model="selectedLayerMap" :disable-branch-nodes="true" multiple
                            valueFormat="object" placeholder="Chọn lớp dữ liệu" />
                    </div>
                    <b-button variant="primary"
                        style="position: absolute;right: -17px;top: 50%;padding-left: 5px;padding-right: 5px;"
                        @click="showLeftSide = !showLeftSide"><i
                            :class="`fa fa-caret-${showLeftSide ? 'left' : 'right'}`" aria-hidden="true"></i></b-button>
                </div>
            </div>
        </div>

        <b-modal v-model="showDataModal" hide-header hide-footer centered size="xl" modal-class="station-modal">
            <Statistic :point="selectedPoint" :mainData="mainData" />
        </b-modal>

        <b-modal v-model="showLayerModal" hide-header hide-footer centered size="xl" modal-class="station-modal">
            <StatisticCompare :point="selectedPoint" :listLayerPoint="listLayerPoint" :mainData="mainData" />
        </b-modal>
        <b-modal title="Đăng ảnh, video" no-close-on-esc no-close-on-backdrop v-model="showModalPhoto">
            <b-form-group label="Vĩ độ">
                <b-form-input v-model="form.lat" v-validate="'required'" placeholder="Vĩ độ" name="lat" type="number"
                    data-vv-as="Vĩ độ"></b-form-input>
                <div v-show="errors.has('lat')" class="validation-message text-danger">
                    {{ errors.first('lat') }}
                </div>
            </b-form-group>
            <b-form-group label="Kinh độ">
                <b-form-input v-model="form.long" v-validate="'required'" placeholder="Kinh độ" type="number"
                    name="long" data-vv-as="Kinh độ"></b-form-input>
                <div v-show="errors.has('long')" class="validation-message text-danger">
                    {{ errors.first('long') }}
                </div>
            </b-form-group>
            <b-form-group label="Mô tả">
                <b-form-textarea v-model="form.description" rows="3" placeholder="Nhập thông tin" />
            </b-form-group>
            <b-form-group label="Liên kết tới lớp dữ liệu">
                <treeselect :searchable="false" :options="listLayerMap" :normalizer="normalizer" v-model="form.layerId"
                    placeholder="Chọn lớp dữ liệu" />
            </b-form-group>
            <b-form-group label="Hình ảnh, video">
                <b-form-file v-model="listFile" accept="image/*,video/*" capture v-validate="'required'" multiple
                    name="listFile" placeholder="Chưa có ảnh, video nào được chọn" browse-text="Chụp"
                    data-vv-as="Hình ảnh, video" />
                <div v-show="errors.has('listFile')" class="validation-message text-danger">
                    {{ errors.first('listFile') }}
                </div>
            </b-form-group>
            <template #modal-footer>
                <b-button variant="secondary" @click="showModalPhoto = false">
                    {{ $t('common.cancel') }}
                </b-button>
                <b-button variant="primary" @click="updateLocate" :disabled="loading">
                    <b-spinner v-if="loading" small /> Thêm
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import API_CONFIG from '@/api-config';
import Statistic from '@/components/StatisticUser';
import StatisticCompare from '@/components/StatisticCompareUser';
import TifLegendInfo from '@/components/TifLegendInfo';
import GeoLegendInfo from '@/components/GeoLegendInfo';
import Timeline from '@/components/Timeline';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import parseGeoraster from 'georaster';
import GeoRasterLayer from 'georaster-layer-for-leaflet';

export default {
    props: ['gestureHandling'],
    components: {
        Statistic,
        Treeselect,
        StatisticCompare,
        TifLegendInfo,
        GeoLegendInfo,
        Timeline
    },
    data() {
        return {
            zoom: window.innerWidth < 768 ? 9 : 10,
            center: [22.3642943, 104.0457989],
            zoomOption: {
                zoomInTitle: 'Phóng to',
                zoomOutTitle: 'Thu nhỏ'
            },
            showDataModal: false,
            showLayerModal: false,
            tileLayerOption: '',
            lat: null,
            long: null,
            selectedBaseMap: [],
            listBaseMap: [],
            selectedLayerMap: [],
            listLayerMap: [],
            listLayerFile: [],
            listLayerActive: {},
            listPoint: [],
            listDataPoint: [],
            listLayerPoint: [],
            listPhoto: [],
            listLayerPhoto: [],
            selectedPoint: {},
            photoLayer: null,
            rasterLayer: null,
            rasterInfo: null,
            geoInfo: null,
            API_CONFIG,
            showLabel: false,
            listGeoPoint: [],
            mapGeoPoint: {},
            loading: false,
            pointLegend: [],
            mainData: null,
            showModalPhoto: false,
            form: {},
            listFile: [],
            showLeftSide: false,
            showLegend: true,
            listSelectedId: [],
            lastLayerSelected: null
        };
    },
    async created() {
        this.listBaseMap = await this.getLayerTree({ type: 'base' });
        this.listLayerMap = await this.getLayerTree({ type: 'layer' });
    },
    async mounted() {
        await this.$nextTick();
        this.initMapControl();
        const config = await this.getConfig({ id: 'point' });
        this.mainData = config?.value?.mainData;
        this.pointLegend = config?.value?.legend || [
            { color: '#ff0000' },
            { color: '#ffa500' },
            { color: '#008000' }
        ];
        this.listPoint = await this.getListPoint();
        this.listDataPoint = this.listPoint.filter(item => !item.layerId);
        this.listPhoto = await this.getListPhoto();

        const map = this.$refs.myMap.mapObject;

        const subGroup = {};

        for (const item of this.listDataPoint) {
            if (!subGroup[item.lat + '-' + item.long]) {
                const parentGroup = L.markerClusterGroup({
                    iconCreateFunction: cluster => {
                        return L.divIcon({
                            html: `<div class="station-bg" style="background-color: ${this.getMarkerColor1(
                                item
                            )}">
                        <div class="font-weight-bold" style="background-color: ${this.getMarkerColor2(
                                item
                            )}">
                            <span>${item?.data?.value}</span></div></div>`
                        });
                    }
                });
                parentGroup.addTo(map);
                const mySubGroup = L.featureGroup.subGroup(parentGroup);
                subGroup[item.lat + '-' + item.long] = mySubGroup;
                mySubGroup.addTo(map);
            }
        }

        for (const item of this.listDataPoint) {
            const mySubGroup = subGroup[item.lat + '-' + item.long];
            const marker = L.marker([item.lat, item.long], {
                icon: L.divIcon({
                    html: `<div class="station-bg" style="background-color: ${this.getMarkerColor1(
                        item
                    )}">
                        <div class="font-weight-bold" style="background-color: ${this.getMarkerColor2(
                        item
                    )}">
                            <span>${item?.data?.value}</span></div></div>`
                })
            });
            marker
                .addTo(mySubGroup)
                .bindTooltip(item.name)
                .on('click', () => {
                    this.openDataModal(item);
                });
        }
        this.selectedBaseMap = this.getDefaultLayer(this.listBaseMap);
        this.selectedLayerMap = this.getDefaultLayer(this.listLayerMap);

        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        selectedBaseMap(newValue, oldValue) {
            this.updateLayer(newValue, oldValue);
        },
        selectedLayerMap(newValue, oldValue) {
            this.listSelectedId = newValue.map(item => item.id);
            this.listLayerPoint = this.listPoint.filter(item =>
                this.listSelectedId.includes(item.layerId)
            );
            this.listLayerPhoto = this.listPhoto.filter(item =>
                this.listSelectedId.includes(item.layerId)
            );
            this.updateLayer(newValue, oldValue);
        },
        showLabel(value) {
            for (const id of Object.keys(this.listLayerActive)) {
                for (const layer of this.listLayerActive[id]) {
                    if (layer instanceof L.GeoJSON) {
                        layer.eachLayer(item => {
                            if (item instanceof L.Marker) {
                                const tooltip = item.getTooltip();
                                if (!tooltip) return;
                                item.unbindTooltip();
                                item.bindTooltip(tooltip.getContent(), {
                                    permanent: value,
                                    direction: 'right',
                                    className: 'point-label'
                                });
                            }
                        });
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions({
            getListPoint: 'point/getList',
            getListPhoto: 'photo/getList',
            getLayerTree: 'mapLayer/getListTree',
            downloadLayerFile: 'mapLayer/downloadFile',
            getConfig: 'config/get',
            upload: 'file/upload',
            createPhotoPoint: 'photo/create'
        }),
        initMapControl() {
            const map = this.$refs.myMap.mapObject;

            const measureControl = new L.Control.Measure({
                position: 'topright',
                activeColor: 'blue',
                completedColor: 'red',
                primaryLengthUnit: 'kilometers',
                secondaryLengthUnit: undefined,
                primaryAreaUnit: 'hectares',
                secondaryAreaUnit: undefined
            });
            measureControl.addTo(map);

            L.control
                .locate({
                    strings: {
                        title: 'Hiển thị vị trí hiện tại',
                        popup: 'Bạn cách vị trí hiện tại {distance} mét'
                    },
                    position: 'topright',
                    onLocationError: e => {
                        this.$toaster.error('Không thể lấy thông tin vị trí hiện tại');
                    }
                })
                .addTo(map);

            this.setUpPrintMap();

            const editableLayers = new L.FeatureGroup();
            map.addLayer(editableLayers);

            const regionMap = L.tileLayer(
                `https://maps.vnpost.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=674052d5aeb7658157d37306d8fc0bb42e7b69cff5e37440`,
                {
                    attribution: ''
                }
            ).addTo(map);
            // const regionMap = L.tileLayer(
            //     `https://gomaps.vnpt.vn/tiles/mapvnpt/v1/{z}/{x}/{y}.png?apiKey=ed001a40-978a-4993-8263-48f707ee6ce6`,
            //     {
            //         attribution: ''
            //     }
            // ).addTo(map);

            const hybridMutant = L.tileLayer.bing({
                bingMapsKey: 'ArA6oVbF7ebYgOJee15IlWHGPsf7CMozhAk343Oi1HhfecgOrnlTSuYuaWaukkHa',
                imagerySet: 'AerialWithLabelsOnDemand',
                culture: 'vi-VN'
            });

            const roadMutant = L.tileLayer.bing({
                bingMapsKey: 'ArA6oVbF7ebYgOJee15IlWHGPsf7CMozhAk343Oi1HhfecgOrnlTSuYuaWaukkHa',
                imagerySet: 'RoadOnDemand',
                culture: 'vi-VN'
            });

            const googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            });

            const googleHybrid = L.tileLayer(
                'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
                {
                    maxZoom: 20,
                    subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                }
            );

            const googleSat = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            });

            const googleTerrain = L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            });

            const baseMap = {
                'Bản đồ hành chính': regionMap,
                'Google Map đường phố': googleStreets,
                'Google Map vệ tinh': googleSat,
                'Google Map vệ tinh kết hợp': googleHybrid,
                'Google Map địa hình': googleTerrain,
                'Bing Map vệ tinh': hybridMutant,
                'Bing Map đường phố': roadMutant
            };

            L.control
                .layers(baseMap, null, {
                    position: 'bottomleft'
                })
                .addTo(map);
        },
        setUpPrintMap() {
            if (this.tileLayerOption != 'Bản đồ số Việt Nam') {
                const typeMap =
                    this.tileLayerOption === 'Google Map vệ tinh' ? 'hybrid' : 'roadmap';
                L.Control.BrowserPrint.Utils.registerLayer(
                    L.GridLayer.GoogleMutant,
                    'L.GridLayer.GoogleMutant',
                    (layer, utils) => {
                        return L.gridLayer.googleMutant({
                            maxZoom: 24,
                            type: typeMap,
                            attribution:
                                '&copy; <a target="_blank" href="https://www.google.com/permissions/geoguidelines/">Google Map</a> contributors'
                        });
                    }
                );
            }

            L.control
                .browserPrint({
                    documentTitle: 'WRI-CosMaDSS',
                    printModes: [
                        L.control.browserPrint.mode(
                            L.Control.BrowserPrint.Mode.Landscape,
                            null,
                            null,
                            null,
                            true
                        )
                    ],
                    manualMode: false
                })
                .addTo(this.$refs.myMap.mapObject);
        },
        async openDataModal(data) {
            this.selectedPoint = data;
            this.showDataModal = true;
        },
        async openLayerModal(data) {
            this.selectedPoint = data;
            this.showLayerModal = true;
        },
        refreshMapView() {
            this.$refs.myMap.mapObject.setView(this.center, this.zoom);
        },
        async showPosition(position) {
            this.lat = position.coords.latitude;
            this.long = position.coords.longitude;
        },
        refreshMap() {
            this.$refs.myMap.mapObject.eachLayer(layer => {
                if (
                    layer instanceof L.Circle ||
                    layer instanceof L.Rectangle ||
                    layer instanceof L.Path ||
                    layer instanceof L.Polygon
                ) {
                    this.$refs.myMap.mapObject.removeLayer(layer);
                }
            });
            this.refreshMapView();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        async updateLayer(newValue, oldValue) {
            this.lastLayerSelected = newValue.findLast(item => item.dataType);
            this.loading = true;
            const map = this.$refs.myMap.mapObject;
            const listRemoved = (oldValue ?? []).filter(item => !(newValue ?? []).includes(item));
            for (const it of listRemoved) {
                const id = it.id;
                delete this.mapGeoPoint[id];
                for (const item of this.listLayerActive[id] ?? []) {
                    map.removeLayer(item);
                }
                if (this.rasterInfo && this.rasterInfo.id === id) {
                    map.removeLayer(this.rasterLayer);
                    this.rasterLayer = null;
                    this.rasterInfo = null;
                }
                if (this.geoInfo && this.geoInfo.id === id) {
                    this.geoInfo = null;
                }
            }

            const listAdded = (newValue ?? []).filter(item => !(oldValue ?? []).includes(item));
            const rasterInfo = listAdded.findLast(item => item.dataType === 'raster');
            if (rasterInfo) {
                this.rasterInfo = rasterInfo;
                const file = this.rasterInfo.files[0];
                if (this.rasterLayer) map.removeLayer(this.rasterLayer);
                const legend = rasterInfo.legend ?? [];
                if (rasterInfo.files.length == 1) {
                    const response = await fetch(
                        `${API_CONFIG.BASE_URL}map-layer/${rasterInfo.id}/download-file?fileName=${file}`
                    );
                    const arrayBuffer = await response.arrayBuffer();
                    const georaster = await parseGeoraster(arrayBuffer);
                    this.rasterLayer = new GeoRasterLayer({
                        georaster,
                        opacity: 0.7,
                        resolution: 256,
                        zIndex: 600,
                        pixelValuesToColorFn: values => {
                            const pixelValue = values[0];
                            if (pixelValue < 0) return null;
                            for (const item of legend) {
                                if (pixelValue <= item.value) return item.color;
                            }
                            return '#000000';
                        }
                    });
                    this.rasterLayer.addTo(map);
                }
            }

            for (const it of listAdded) {
                const id = it.id;
                this.listLayerActive[id] = [];
                if (it.dataType != 'geojson') continue;
                for (const fileName of it.files) {
                    try {
                        const legend = it.legend ?? [];
                        const content = await this.downloadLayerFile({ id, fileName });
                        if (content.features.length === 0) continue;
                        const key = Object.keys(content.features[0].properties)[1];
                        this.geoInfo = {
                            id,
                            fileName,
                            name: it.name,
                            type: it.type,
                            legend
                        };
                        this.mapGeoPoint[id] = [];
                        for (const feature of content.features) {
                            if (feature.geometry.type === 'Point') {
                                const lat = feature.geometry.coordinates[1];
                                const long = feature.geometry.coordinates[0];
                                const point = this.listPoint.find(
                                    item => (item.lat - lat) ** 2 + (item.long - long) ** 2 < 0.01
                                );
                                if (point) this.mapGeoPoint[id].push(point);
                            }
                        }
                        this.listGeoPoint = Object.values(this.mapGeoPoint).flat();
                        const layer = L.geoJSON(content, {
                            style: feature => {
                                if (legend.length == 0) {
                                    const color =
                                        '#' + Math.floor(Math.random() * 16777215).toString(16);
                                    return { weight: 0.5, color };
                                }
                                const value = feature.properties[key];
                                for (const item of legend) {
                                    if (value <= item.value)
                                        return { weight: 0.5, color: item.color };
                                }
                                return { weight: 0.5, color: '#000' };
                            },
                            pointToLayer: (feature, latlng) => {
                                const label = String(feature.properties.name);
                                let iconUrl = '/img/add.png';
                                if (it.pointIcon) {
                                    iconUrl =
                                        API_CONFIG.BASE_URL + 'download?fileName=' + it.pointIcon;
                                }
                                return L.marker(latlng, {
                                    icon: L.icon({
                                        iconUrl,
                                        iconSize: [it.iconSize ?? 20]
                                    })
                                }).bindTooltip(label, {
                                    permanent: this.showLabel,
                                    direction: 'right',
                                    className: 'point-label'
                                });
                            },
                            onEachFeature: (feature, layer) => {
                                if (feature.properties) {
                                    let body = '';
                                    for (const key in feature.properties) {
                                        body += `<tr><td style="font-weight: bold">${key}</td><td>${feature.properties[key]}</td></tr>`;
                                    }
                                    let popupContent = `<table class="geojson-table table-striped table-bordered">${body}</table>`;
                                    const popupContentElement = document.createElement('div');
                                    popupContentElement.innerHTML = popupContent;

                                    const point = this.listGeoPoint.find(
                                        item =>
                                            (item.lat - layer.getLatLng().lat) ** 2 +
                                            (item.long - layer.getLatLng().lng) ** 2 <
                                            0.01
                                    );
                                    if (point) {
                                        const button = document.createElement('button');
                                        button.className = 'btn btn-primary btn-sm mt-2';
                                        button.innerText = 'Xem dữ liệu';
                                        button.onclick = () => {
                                            this.selectedPoint = point;
                                            if (point.layerId) {
                                                this.openLayerModal(this.selectedPoint);
                                            } else this.openDataModal(this.selectedPoint);
                                        };
                                        popupContentElement.appendChild(button);
                                    }
                                    layer.bindPopup(popupContentElement);
                                }
                            }
                        });
                        this.listLayerActive[id].push(layer);
                        layer.addTo(map);
                    } catch (error) { }
                }
            }
            this.listGeoPoint = Object.values(this.mapGeoPoint).flat();
            this.loading = false;
        },
        isImage(url) {
            return url.match(/\.(jpeg|jpg|gif|png|svg|webp|bmp|ico|tiff|tif|raw|heif|heic)$/);
        },
        getMarkerColor1(item) {
            if (!item.data) return '#00800080';
            for (const it of this.pointLegend) {
                if (item.data.value <= it.value) return it.color + '80';
            }
            return '#00800080';
        },
        getMarkerColor2(item) {
            if (!item.data) return '#008000';
            for (const it of this.pointLegend) {
                if (item.data.value <= it.value) return it.color;
            }
            return '#008000';
        },
        openUploadImageModal() {
            this.showModalPhoto = true;
            this.form = {};
            this.listFile = [];
            this.setCurrentLocation();
        },
        async updateLocate(modal) {
            modal.preventDefault();
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.loading = true;
            for (const file of this.listFile) {
                const data = await this.upload({ formData: { file } });
                this.form.images = this.form.images || [];
                this.form.images.push(data.path);
            }
            await this.createPhotoPoint(this.form);
            this.showModalPhoto = false;
            this.listPhoto = await this.getListPhoto();
            this.listLayerPhoto = this.listPhoto.filter(item =>
                this.listSelectedId.includes(item.layerId)
            );
            this.$toaster.success('Thành công');
            this.loading = false;
        },
        setCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showPosition);
            } else {
                this.$toaster.error('Không thể lấy thông tin vị trí hiện tại');
            }
        },
        async showPosition(position) {
            this.form = {
                lat: position.coords.latitude.toFixed(4),
                long: position.coords.longitude.toFixed(4)
            };
        },
        getPhotoIcon(item) {
            if (!item.layer?.pointIcon) return '/img/image.png';
            return API_CONFIG.BASE_URL + 'download?fileName=' + item.layer.pointIcon;
        },
        formatNumber(value) {
            if (value == null) return '';
            if (value % 1 === 0) return value;
            return value.toFixed(1);
        },
        getDefaultLayer(listLayer) {
            let list = [];
            for (const item of listLayer) {
                if (item.children && item.children.length > 0) {
                    list = list.concat(this.getDefaultLayer(item.children));
                } else {
                    if (item.defaultShow) list.push(item);
                }
            }
            return list;
        },
        async onTimeChange(file) {
            const map = this.$refs.myMap.mapObject;
            const response = await fetch(
                `${API_CONFIG.BASE_URL}map-layer/${this.rasterInfo.id}/download-file?fileName=${file}`
            );
            if (this.rasterLayer) map.removeLayer(this.rasterLayer);
            const arrayBuffer = await response.arrayBuffer();
            const georaster = await parseGeoraster(arrayBuffer);
            const legend = this.rasterInfo.legend ?? [];
            this.rasterLayer = new GeoRasterLayer({
                georaster,
                opacity: 0.7,
                resolution: 256,
                zIndex: 600,
                pixelValuesToColorFn: values => {
                    const pixelValue = values[0];
                    if (pixelValue <= 0) return null;
                    for (const item of legend) {
                        if (pixelValue <= item.value) return item.color;
                    }
                    return '#000000';
                }
            });
            this.rasterLayer.addTo(map);
        },
        handleClickOutside(event) {
            if (!this.showLeftSide) return;
            const leftSidePanel = this.$refs.leftSidePanel;
            if (leftSidePanel && !leftSidePanel.contains(event.target)) {
                this.showLeftSide = false;
            }
        }
    }
};
</script>
<style lang="scss">
.leaflet-popup-content {
    text-align: center !important;
}

.leaflet-marker-photo b {
    height: 16px !important;
    min-width: 16px !important;
}

.leaflet-control-browser-print {
    display: none !important;
}

.leaflet-draw-actions a {
    color: white !important;
}

.station-bg {
    margin-left: -12px !important;
    margin-top: -12px !important;
    width: 32px !important;
    height: 32px !important;
    z-index: 302 !important;
    background-clip: padding-box;
    border-radius: 20px;

    div {
        width: 24px;
        height: 24px;
        margin-left: 4px;
        margin-top: 4px;
        text-align: center;
        border-radius: 15px;
        font-weight: 700;
        color: #fff;
        display: inline-block;
    }

    span {
        line-height: 24px;
    }
}

.geojson-type {
    color: black;
    margin-right: 0px !important;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);

    .nav-link {
        padding: 0.5rem 0.85rem !important;
        color: black;
    }

    button {
        padding: 0.45rem !important;
    }
}

.leaflet-control-search {
    .search-input {
        min-width: 150px;
    }
}

.station-modal {
    .modal-content {
        border-radius: 10px;

        .modal-body {
            padding: 0.5rem;
        }
    }
}

.photo-img {
    width: 200px;
    height: auto;
}

@media screen and (max-width: 500px) {
    .station-modal {
        .modal-dialog {
            margin: 1.75rem;
        }
    }

    .btn-label {
        display: none;
    }

    .photo-img {
        max-width: 30%;
        height: auto;
    }
}

.detail-card {
    border-radius: 10px;

    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.history-card {
    border-radius: 10px;
    margin-bottom: 0;

    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.region-label {
    font-size: 14px;
    z-index: 400 !important;
    height: auto !important;
    width: 90px !important;
}

.leaflet-tooltip.point-label {
    color: orange;
}

.geojson-table {

    th,
    td {
        padding: 4px;
        text-align: left;
    }
}
</style>
